import { render } from "./DoorCard.vue?vue&type=template&id=95d4ba3e&scoped=true&ts=true"
import script from "./DoorCard.vue?vue&type=script&lang=ts"
export * from "./DoorCard.vue?vue&type=script&lang=ts"

import "./DoorCard.vue?vue&type=style&index=0&id=95d4ba3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d4ba3e"]])

export default __exports__